export const createIntegration = ({ token, body }) => ({
  HTTPMethod: "post",
  path: "/api/v1/conduit/integrations",
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body,
});
